<template lang="pug">
  .absolute.inset-0
    template(v-if="show")
      //- full bleed
      template(v-if="format === 'full-bleed'")
        resp-img(v-if="image", :bg="true", :winLngth="1", :useHeight="isPortrait", :src="image.url", :alt="image.alt", :key="image.url", @loaded="onLoaded")
      //- has margins
      template(v-else)
        .absolute.top-72.left-0.w-full.px-24.lg-px-72.h-screen_-144.flex.items-center.overflow-hidden
          resp-img.w-full(:src="image.url", :alt="image.alt", :winLngth="0.9", @loaded="onLoaded")
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import RespImg from '@/components/RespImg'
export default {
  name: 'Slide--Image',
  props: ['slice', 'visible', 'index', 'preload', 'near', 'muted'],
  components: { RespImg },
  data () {
    return {
      shown: false // once shown, stay mounted so the image is not fetched twice
    }
  },
  computed: {
    ...mapState(['winW', 'winH']),
    ...mapGetters(['isPortrait']),
    show () {
      return this.visible || this.preload || this.near || this.shown
    },
    image () {
      const isBleed = this.format === 'full-bleed'
      const image = this.slice.primary.image
      const portraitImg = image.portrait || image
      return isBleed && this.isPortrait ? portraitImg : image
    },
    format () {
      return this.slice.primary.format
    }
  },
  methods: {
    onLoaded () {
      this.$emit('ready')
    }
  },
  watch: {
    visible (vis) {
      if (vis) this.shown = true
    }
  }
}
</script>

<style>
</style>
